import { render, staticRenderFns } from "./pcSubmit.vue?vue&type=template&id=287a38e4&scoped=true&"
import script from "./pcSubmit.vue?vue&type=script&lang=js&"
export * from "./pcSubmit.vue?vue&type=script&lang=js&"
import style0 from "./pcSubmit.vue?vue&type=style&index=0&id=287a38e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287a38e4",
  null
  
)

export default component.exports